import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import MainApp from "./components/MainApp";
import PrivacyPolicyPage from "./components/PrivacyPolicyPage";
import BookConsultation from "./components/BookConsultation";
import SubmissionSuccess from "./components/SubmissionSuccess";
import SubmissionFail from "./components/SubmissionFail";
import AttributionTracker from "./components/AttributionTracker";
import ServicesPage from "./components/ServicesPage";
import ProductsPage from "./components/ProductsPage";
import ProcessPage from "./components/ProcessPage";

function App() {
  return (
    <Router>
      <AttributionTracker />
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/book-consultation" element={<BookConsultation />} />
        <Route path="/submission-success" element={<SubmissionSuccess />} />
        <Route path="/submission-fail" element={<SubmissionFail />} />
      </Routes>
    </Router>
  );
}

export default App;
